const HBO_LOGIN = '/hbologin';
const ESPN_LOGIN = '/espn-login'

export { HBO_LOGIN, ESPN_LOGIN };
